export default __webpack_public_path__ + "static/media/confirm.d75d6cdd.png";